
import React from "react";
import { Classname } from "@rivtn/noseur";
import { IAchievement } from "../../data";
import styles from "../../assets/style.module.css";

export interface TrophyCardProps {
    index?: number;
    visible?: boolean;
    showDesc?: boolean;
    achievement: IAchievement;
}

function TrophyCard({ achievement: a, index = 0, visible = true, showDesc }: TrophyCardProps) {
    return (<div className={Classname.build(styles["trophy"], styles["reveal"], { [styles["in-view"]]: visible })} style={{ transitionDelay: `${index * 0.05}s` }}>
        <div className={styles["trophy-icon"]}><i className={a.icon} /></div>
        <div className={styles["trophy-year"]}>{a.year}</div>
        <div className={styles["trophy-title"]}>{a.title}</div>
        {showDesc && (<div className={styles["trophy-desc"]}>{a.desc}</div>)}
    </div>);
}

export default TrophyCard;
